import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/embed/jadwal-sholat/$kota")({
  component: () => <Outlet />,
});